// Allowlist tim dev untuk halaman /dev — SUMBER TUNGGAL.
// Client-safe & edge-safe (TANPA import `pg`) supaya bisa dipakai di middleware,
// server component, API, maupun client component.
//
// Board sprint = 3 dev (Miqdam, Dimas, Brian). Federico = supervisor read-only
// (bisa lihat, tidak bisa mutasi). Selain 4 email ini → route /dev tak terlihat (404).

export const DEV_TEAM = [
  { email: 'miqdam@jalgroup.id', name: 'Miqdam JAL' },
  { email: 'dimas@jalgroup.id', name: 'Dimas Pujangga' },
  { email: 'brian@jalgroup.id', name: 'Brian' },
] as const

export const SUPERVISORS = [
  { email: 'federicotan@jalgroup.id', name: 'Federico Tan' },
] as const

/** Lead = hak penuh (create/assign/geser semua task + CRUD sprint). */
export const LEAD_EMAIL = 'brian@jalgroup.id'

/** Kapasitas default per dev per minggu (points) → dasar warning overload & heatmap. */
export const DEV_CAPACITY_POINTS = 8

const lc = (s?: string | null) => (s ?? '').trim().toLowerCase()

export const DEV_EMAILS: string[] = DEV_TEAM.map((d) => d.email)
export const SUPERVISOR_EMAILS: string[] = SUPERVISORS.map((s) => s.email)

/** Anggota board (3 dev). */
export const isDevTeam = (email?: string | null): boolean => DEV_EMAILS.includes(lc(email))
/** Supervisor (read-only). */
export const isSupervisor = (email?: string | null): boolean => SUPERVISOR_EMAILS.includes(lc(email))
/** Boleh membuka /dev sama sekali (dev atau supervisor). */
export const isDevAllowed = (email?: string | null): boolean => isDevTeam(email) || isSupervisor(email)
/** Lead (Brian). */
export const isLead = (email?: string | null): boolean => lc(email) === LEAD_EMAIL

/** Nama tampilan dari email (dev atau supervisor), atau null. */
export const devName = (email?: string | null): string | null =>
  DEV_TEAM.find((d) => d.email === lc(email))?.name ??
  SUPERVISORS.find((s) => s.email === lc(email))?.name ??
  null
